import React from "react";
import aboutImage from "./Mounilogo.png"; // update path as per your project structure

export default function Hero() {
  return (
    <section className="px-6 md:px-12 py-16 ">
      <div className="flex flex-col md:flex-row items-center max-w-7xl mx-auto gap-10">
        {/* Image Section */}
        <div className="md:w-1/3">
          <img
            src={aboutImage}
            alt="About Technosoft IT Services"
            className="rounded-3xl  w-full object-cover"
          />
        </div>

        <div className="md:w-1/2 md:pl-8 text-center md:text-left">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-snug">
            Technosoft IT Services <span className="text-purple-700">- Innovative Way To Learn</span>
          </h2>
          <div className="h-1 w-24 bg-purple-700 rounded-full mb-6 mx-auto md:mx-0"></div>
          <p className="text-gray-700 mb-4 text-base md:text-lg leading-relaxed">
            Technosoft IT Services is a premier online training and placement organization, specializing in Training, Corporate Training, Job Assistance, and Placement.
          </p>
          <p className="text-gray-700 mb-4 text-base md:text-lg leading-relaxed">
            Each year, we empower over 5,500+ professionals and students from the USA, UK, Canada, Australia, and around the world. With 100+ courses taught by seasoned industry experts, our interactive sessions ensure practical, real-world knowledge.
          </p>
          <p className="text-gray-700 mb-6 text-base md:text-lg leading-relaxed">
            Our expert trainers, actively working on live projects, deliver affordable courses meticulously designed to help you ace client interviews and build successful careers.
          </p>
          <button className="px-6 py-3 bg-purple-700 text-white text-base md:text-lg font-semibold rounded-xl shadow-md hover:bg-purple-800 hover:scale-105 transform transition duration-300">
            Learn More
          </button>
        </div>
      </div>
    </section>
  );
}